import { render, staticRenderFns } from "./OfferSignatureSettings.vue?vue&type=template&id=c540bb0c&scoped=true&"
import script from "./OfferSignatureSettings.vue?vue&type=script&lang=js&"
export * from "./OfferSignatureSettings.vue?vue&type=script&lang=js&"
import style0 from "./OfferSignatureSettings.vue?vue&type=style&index=0&id=c540bb0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c540bb0c",
  null
  
)

export default component.exports